<template>
  <div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="apply-width-two" scope="col">Año</th>
          <th class="apply-width" colspan="2" scope="col">Iniciativa</th>
          <th class="apply-width-four" scope="col">Estado de Avance</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, selectedData) in selectedData" :key="selectedData">
          <td>{{ item.añO }}</td>
          <td class="tdas" colspan="2">{{ item.iniciativA }}</td>
          <td>{{ item.estadoAvancE }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: ["selectedData"],
  data() {
    return {};
  },
};
</script>

<style scoped>
.text-sm {
  font-size: 0.8rem;
}
th {
  text-align: left !important;
  font-size: 14px !important ;
}

td {
  text-align: center;
}

.table {
  border: 1px solid #ccc;
}

.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
  text-align: left;
}

.div {
  width: 96%;
  height: 26px;
  position: relative;
  left: 3px;
  background-color: #fff;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  width: 50%;
  padding: 5px;
  text-align: left !important;
  font-size: 13px;
}

td {
  text-align: left;
  font-size: 16px;
}
</style>
